import { createAction } from '@reduxjs/toolkit';

export const setLoginModal = createAction<{ isOpen: boolean }>('login/SET_LOGIN_MODAL');
export const closeLoginWithoutAction = createAction('login/CLOSE_WITHOUT_ACTION');
export const setAuthRedirect = createAction<{ onAuthRedirect?: string }>('login/SET_AUTH_REDIRECT');
export const setCreateProfileRedirect = createAction<{ redirect: string }>('login/SET_CREATE_PROFILE_REDIRECT');
export const activateAuthRedirect = createAction('login/ACTIVATE_REDIRECT');
export const setAuthLogout = createAction<{ isLogout: boolean }>('login/SET_AUTH_LOGOUT');
